// extracted by mini-css-extract-plugin
module.exports = {"progress":"styles_progress__1z_PR","spinner":"styles_spinner__1INps","pending":"styles_pending__2EQEG","spin":"styles_spin__2oW6_"};